import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
  Typography,
} from '@mui/material'
import { Control, Controller } from 'react-hook-form'

type RadioItems = {
  label: string
  value: string
}

type RadioProps = {
  name: string
  label: string
  control: Control<any>
  items: RadioItems[]
} & RadioGroupProps

const FormRadio = (props: RadioProps) => {
  const { name, control, items, label } = props

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl variant="standard">
          <FormLabel>
            <Typography
              color="black"
              variant="body1"
              component="span"
              fontWeight={700}
              fontSize={{
                md: '14px !important',
                xs: '12px !important',
              }}
            >
              {label}
            </Typography>
          </FormLabel>
          <RadioGroup row {...field}>
            {items.map((item, index) => (
              <FormControlLabel
                key={index}
                {...item}
                aria-label={item.label}
                control={<Radio disableRipple />}
              />
            ))}
          </RadioGroup>
        </FormControl>
      )}
    />
  )
}

export default FormRadio
